export const getStorageToken = () => {
    // Check localStorage
    const localStorageToken = localStorage.getItem('token')
    const localStorageTimestamp = localStorage.getItem('tokenTimestamp')
    if (localStorageToken && localStorageTimestamp) {
        const expirationTime = new Date(localStorageTimestamp).getTime() + 3600000 // One hour in milliseconds
        if (new Date().getTime() < expirationTime) {
            return localStorageToken
        } else {
            // Token has expired
            removeTokenFromStorage('localStorage')
        }
    }
    // Check sessionStorage
    const sessionStorageToken = sessionStorage.getItem('token')
    const sessionStorageTimestamp = sessionStorage.getItem('tokenTimestamp')
    if (sessionStorageToken && sessionStorageTimestamp) {
        const expirationTime = new Date(sessionStorageTimestamp).getTime() + 3600000 // One hour in milliseconds
        if (new Date().getTime() < expirationTime) {
            return sessionStorageToken
        } else {
            // Token has expired
            removeTokenFromStorage('sessionStorage')
        }
    }
    return null
}

export const setTokenInStorage = (storageType, token) => {
    if (storageType !== 'localStorage' && storageType !== 'sessionStorage') {
        return false
    }
    // Set token based on the specified storage type
    window[storageType].setItem('token', token)
    // Set actual time when the token has been set
    window[storageType].setItem('tokenTimestamp', new Date().toISOString())
    return true
}

export const removeTokenFromStorage = (storageType) => {
    if (storageType !== 'localStorage' && storageType !== 'sessionStorage') {
        return false
    }
    // Set token based on the specified storage type
    window[storageType].removeItem('token')
    window[storageType].removeItem('tokenTimestamp')
    return true
}

export const getTokenStorageType = () => {
    // Check localStorage
    const localStorageToken = localStorage.getItem('token')
    if (localStorageToken) {
        return 'localStorage'
    }

    // Check sessionStorage
    const sessionStorageToken = sessionStorage.getItem('token')
    if (sessionStorageToken) {
        return 'sessionStorage'
    }
    return null
}
